import card from "../../assets/images/card.svg";
import card2 from "../../assets/images/card2.jpg";
import card3 from "../../assets/images/card3.jpg";
import card4 from "../../assets/images/card4.jpg";
import card5 from "../../assets/images/card5.jpg";
import card6 from "../../assets/images/card6.jpg";
import card7 from "../../assets/images/card7.jpg";
import card8 from "../../assets/images/card8.jpg";
import card9 from "../../assets/images/card9.jpg";
import card10 from "../../assets/images/card10.jpg";
import card11 from "../../assets/images/card11.jpg";
import card12 from "../../assets/images/card12.jpg";
import card13 from "../../assets/images/card13.jpg";
import placeholder from "../../assets/images/placeholder.jpeg";

import Card from "./Card";

export const getCardImageBySeriesId = (seriesId) => {
  if (seriesId == 1) {
    return card;
  } else if (seriesId == 2) {
    return card2;
  } else if (seriesId == 3) {
    return card3;
  } else if (seriesId == 4) {
    return card4;
  } else if (seriesId == 5) {
    return card5;
  } else if (seriesId == 6) {
    return card6;
  } else if (seriesId == 7) {
    return card7;
  } else if (seriesId == 8) {
    return card8;
  } else if (seriesId == 9) {
    return card9;
  } else if (seriesId == 10) {
    return card10;
  } else if (seriesId == 11) {
    return card11;
  } else if (seriesId == 12) {
    return card12;
  } else if (seriesId == 13) {
    return card13;
  } else return placeholder;
};

const EnsCard = ({ seriesId, ...props }) => {
  return <Card {...props} image={getCardImageBySeriesId(seriesId)} />;
};

export default EnsCard;
